import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';

@Component({
  selector: 'app-healthcare',
  templateUrl: './healthcare.component.html',
  styleUrls: ['./healthcare.component.scss']
})
export class HealthcareComponent implements OnInit {
  safeURL; //youTube Video URL //

  constructor(
    private meta: Meta, 
    private title: Title, 
    private _sanitizer: DomSanitizer,
    private metaService: MetaServiceService) {
    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'Take a healthcare survey and conduct White-label Patient Experience survey and get real-time data analytics about what they think about your services.' },
      { name: 'author', content: 'CViewSurvey' },
      { name: 'keywords', content: 'Patient satisfaction survey app , patient satisfaction survey covid , patient satisfaction survey in healthcare , Client satisfaction survey , patient satisfaction survey checklist , patient satisfaction survey clinic , patient satisfaction survey for physical therapy , patient satisfaction survey and quality of care' }
    ]);

    this.setTitle('patient satisfaction surveys |  Healthcare survey app for Hospital');
    // End SEO Meta Description


    // You Tube Video Description
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/SDZX7YnSAyM?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1');
    // End You Tube Video Description

  }


  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description

  ngOnInit() {
    // for create canonical link 
    this.metaService.createCanonicalURL();
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

}
